import request from '@/utils/market/marketing'
// 消费者管理
export function vipsearch(data) { // 消费者查询
    return request({
      url: '/mtscitech/back/usermanager/search',
      method: 'post',
      data
    })
  }
  export function updatestate(query) { // 查所有规则分页不含其他 条件
    return request({
      url: '/mtscitech/back/usermanager/updatestate',
      method: 'get',
      params: query
    })
  }
  // 会员记录
export function searchresults(data) { 
    return request({
      url: '/mtscitech/back/memberrecord/searchresults',
      method: 'post',
      data
    })
  }
    // 奖励排行统计
export function searchawardsummaries(data) { 
    return request({
      url: '/mtscitech/back/memberrecord/searchawardsummaries',
      method: 'post',
      data
    })
  }
  // 终端/厨师长
  //终端管理
  export function searchusers(data) { 
    return request({
      url: '/mtscitech/back/memberrecord/searchusers',
      method: 'post',
      data
    })
  }
    //积分兑换流水
    export function searchgoods(data) { 
        return request({
          url: '/mtscitech/back/memberrecord/searchgoods',
          method: 'post',
          data
        })
      }
  //推荐人流水
    export function searchreferences(data) {
        return request({
          url: '/mtscitech/back/memberrecord/searchreferences',
          method: 'post',
          data
        })
      }